/**
 * Storezone — LoadingPage
 * Full-page skeleton loading placeholder.
 */

import { Skeleton } from '@/components/ui'

export function LoadingPage({ message }: { message?: string } = {}) {
  return (
    <div style={{ padding: 'var(--sz-space-8) var(--sz-space-6)', display: 'flex', flexDirection: 'column', gap: 'var(--sz-space-4)' }}>
      <Skeleton width={180} height={28} />
      {message ? <p style={{ fontSize: '0.875rem', color: 'var(--sz-text-3)' }}>{message}</p> : <Skeleton width="60%" height={16} />}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 'var(--sz-space-4)', marginTop: 'var(--sz-space-4)' }}>
        {[1, 2, 3].map((i) => (
          <div key={i} style={{ border: '1px solid var(--sz-border)', borderRadius: 'var(--sz-radius-lg)', padding: 'var(--sz-space-5)', display: 'flex', flexDirection: 'column', gap: 'var(--sz-space-3)' }}>
            <Skeleton width={40} height={40} radius="50%" />
            <Skeleton width="80%" height={18} />
            <Skeleton width="50%" height={14} />
          </div>
        ))}
      </div>
    </div>
  )
}
